"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoastalErosionEstimatedDistanceLostTerm$ = exports.CoastalErosionEstimatedDistanceLostTerm$outboundSchema = exports.CoastalErosionEstimatedDistanceLostTerm$inboundSchema = void 0;
exports.coastalErosionEstimatedDistanceLostTermToJSON = coastalErosionEstimatedDistanceLostTermToJSON;
exports.coastalErosionEstimatedDistanceLostTermFromJSON = coastalErosionEstimatedDistanceLostTermFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const coastalerosionestimateddistancelosttermrisk_js_1 = require("./coastalerosionestimateddistancelosttermrisk.js");
/** @internal */
exports.CoastalErosionEstimatedDistanceLostTerm$inboundSchema = z.object({
    average_estimated_value: z.nullable(z.number()),
    estimated_value_lower_bound: z.nullable(z.number()),
    estimated_value_upper_bound: z.nullable(z.number()),
    risk: z.nullable(coastalerosionestimateddistancelosttermrisk_js_1.CoastalErosionEstimatedDistanceLostTermRisk$inboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "average_estimated_value": "averageEstimatedValue",
        "estimated_value_lower_bound": "estimatedValueLowerBound",
        "estimated_value_upper_bound": "estimatedValueUpperBound",
    });
});
/** @internal */
exports.CoastalErosionEstimatedDistanceLostTerm$outboundSchema = z.object({
    averageEstimatedValue: z.nullable(z.number()),
    estimatedValueLowerBound: z.nullable(z.number()),
    estimatedValueUpperBound: z.nullable(z.number()),
    risk: z.nullable(coastalerosionestimateddistancelosttermrisk_js_1.CoastalErosionEstimatedDistanceLostTermRisk$outboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        averageEstimatedValue: "average_estimated_value",
        estimatedValueLowerBound: "estimated_value_lower_bound",
        estimatedValueUpperBound: "estimated_value_upper_bound",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var CoastalErosionEstimatedDistanceLostTerm$;
(function (CoastalErosionEstimatedDistanceLostTerm$) {
    /** @deprecated use `CoastalErosionEstimatedDistanceLostTerm$inboundSchema` instead. */
    CoastalErosionEstimatedDistanceLostTerm$.inboundSchema = exports.CoastalErosionEstimatedDistanceLostTerm$inboundSchema;
    /** @deprecated use `CoastalErosionEstimatedDistanceLostTerm$outboundSchema` instead. */
    CoastalErosionEstimatedDistanceLostTerm$.outboundSchema = exports.CoastalErosionEstimatedDistanceLostTerm$outboundSchema;
})(CoastalErosionEstimatedDistanceLostTerm$ || (exports.CoastalErosionEstimatedDistanceLostTerm$ = CoastalErosionEstimatedDistanceLostTerm$ = {}));
function coastalErosionEstimatedDistanceLostTermToJSON(coastalErosionEstimatedDistanceLostTerm) {
    return JSON.stringify(exports.CoastalErosionEstimatedDistanceLostTerm$outboundSchema.parse(coastalErosionEstimatedDistanceLostTerm));
}
function coastalErosionEstimatedDistanceLostTermFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.CoastalErosionEstimatedDistanceLostTerm$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'CoastalErosionEstimatedDistanceLostTerm' from JSON`);
}
//# sourceMappingURL=coastalerosionestimateddistancelostterm.js.map